// https://flickity.metafizzy.co/options.html
import Flickity from "flickity";
window.Flickity = Flickity